module.exports = __webpack_public_path__ + "6ed42181f2c1ad98a1d75ee22f10fad3.svg";